<template>
  <Navbar />
  <Home />
  <Kegiatan />
  <Teknopedia />
  <Tentang />
  <Presensi />
  <FAQ />
  <Footer />
</template>

<script setup>
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
import Home from "./views/Home.vue";
import Kegiatan from "./views/Kegiatan.vue";
import Teknopedia from "./views/Teknopedia.vue";
import Tentang from "./views/Tentang.vue";
import Presensi from "./views/Presensi.vue";
import FAQ from "./views/FAQ.vue";
</script>
